module.exports = __webpack_public_path__ + "img/freebg.daebd084.png";